module.exports = __webpack_public_path__ + "static/media/Blog02.6246dca1.jpg";